import { useQuery } from '@tanstack/react-query';
import {
  type FeatureFlagControllerAtMeQueryParamsKeyEnumKey,
  featureFlagControllerAtMeQueryOptions,
} from 'korint-sdk';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

export function FeatureFlagRoute({
  flag,
  productId,
  children,
}: {
  flag: FeatureFlagControllerAtMeQueryParamsKeyEnumKey;
  productId?: string;
  children: ReactNode;
}) {
  const { data, isPending } = useQuery({
    ...featureFlagControllerAtMeQueryOptions({ key: flag, productId }),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  if (isPending) {
    return null;
  }

  return data?.enabled ? children : <Navigate to="/" replace />;
}
